import { getApi, getApiById, putApi, putApiWithoutId } from "../../Shared/Services/RestService";
import { Notification } from "../../Shared/Types/Notification";


export const getAllNotificationByUser= () => {
  return getApi<Notification[]>("/notifications/me");
};

export const markNotificationAsRead = (id: string) => {
  return putApiWithoutId<Notification>(`/notifications/${id}/read`);
};